/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import Skeleton from "@mui/material/Skeleton";

import { colors } from "@dotnet/telematics-design-system";

const ScheduleCardLoader = () => {
  const { gray100 } = colors;

  return (
    <div data-testid="schedule-card-loader">
      <Skeleton
        variant="rectangular"
        height="16px"
        width="216px"
        css={css({
          background: gray100,
          borderRadius: "46px",
          marginBottom: "8px"
        })}
      />
      <Skeleton
        variant="rectangular"
        height="16px"
        width="129px"
        css={css({
          background: gray100,
          borderRadius: "46px"
        })}
      />
    </div>
  );
};

export default ScheduleCardLoader;
